import styled, { css } from "styled-components";

export const PlanCardContainer = styled.div`
    min-width: 0;
`;

export const PlanCardListContainer = styled.div`
    display: grid;
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    margin-bottom: 16px;
    ${p =>
        p.theme.md.only(css`
            grid-template-columns: 1fr 1fr;
        `)}

    ${p =>
        p.theme.lg(css`
            grid-template-columns: 1fr 1fr;
        `)}
    ${p =>
        p.theme.sm.max(css`
            grid-template-columns: 1fr;
        `)}
`;
